export const NavLinksData = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Remedies', path: '/remedies' },
    { name: 'USA Affiliation', path: '/usa-affiliation' },
    { name: 'Business Opportunity', path: '/business-opportunity' },
    // { name: 'Price', path: '/' },
    { name: 'Blogs', path: '/blogs' },
];

export const ProcessData = [
    {
        icon: 'https://designingmedia.com/artelligence/wp-content/uploads/2025/08/service-icon-1.png',
        title: '1. 100% Automated Process',
        description: ['AI Enabled Technology', 'Works without Human Intervention', 'No Device or Gadget required', 'Process works on your Mobile/Laptop']
    },
    {
        icon: 'https://designingmedia.com/artelligence/wp-content/uploads/2025/08/service-icon-2.png',
        title: '2. Iris Scanning through AI',
        description: ['AI validates your eyes first', 'AI Scans your Iris through Mobile/Laptop', 'AI Analyses your Iris scans']
    },
    {
        icon: 'https://designingmedia.com/artelligence/wp-content/uploads/2025/08/service-icon-5.png',
        title: '3. AI analyses your Iris',
        description: ['AI analyses your Iris', 'AI evaluates your Brain’s Neurons', 'AI generates a detailed report of Iris Analysis within minutes']
    },
    {
        icon: 'https://designingmedia.com/artelligence/wp-content/uploads/2025/08/service-icon-3.png',
        title: '4. Counseling',
        description: ['A Certified Iris Analyst & Counselor conducts your counseling', 'Helps you understand your Iris Analysis Report in depth']
    }
];

export const PartnerLogosData = [
    'https://designingmedia.com/artelligence/wp-content/uploads/2025/09/slider-logo-1.png',
    'https://designingmedia.com/artelligence/wp-content/uploads/2025/09/slider-logo-2.png',
    'https://designingmedia.com/artelligence/wp-content/uploads/2025/09/slider-logo-3.png',
    'https://designingmedia.com/artelligence/wp-content/uploads/2025/09/slider-logo-4.png',
    'https://designingmedia.com/artelligence/wp-content/uploads/2025/09/slider-logo-5.png'
];

export const PlansData = [
    {
        name: 'Starter Plan', description: 'Ideal for individuals and small teams getting started with AI', price: '49', features: [
            { text: 'Access to AI Sandbox (basic tier)', included: true },
            { text: '10,000 API calls/month', included: true },
            { text: '1 Robotics simulation project', included: true },
            { text: 'Community support', included: true },
            { text: 'AI model templates (pre-trained)', included: true },
            { text: 'Custom LLM tuning', included: false }
        ], buttonText: 'Start Free Trial', popular: false
    },
    {
        name: 'Pro Plan', description: 'Best for growing businesses needing advanced features and scale.', price: '79', features: [
            { text: '100,000 API calls/month', included: true },
            { text: '10 Robotics simulation environments', included: true },
            { text: 'NeuralVision & RoboSim tools access', included: true },
            { text: 'Team collaboration (up to 10 users)', included: true },
            { text: 'Email & ticket support', included: true },
            { text: 'Custom LLM tuning (beta)', included: true }
        ], buttonText: 'Upgrade to Pro', popular: true
    },
    {
        name: 'Enterprise Plan', description: 'Designed for large-scale operations and custom AI solutions', price: '199', features: [
            { text: 'Unlimited API access', included: true },
            { text: 'Custom robotics integrations', included: true },
            { text: 'On-premise or private cloud deployment', included: true },
            { text: 'AI explainability & compliance tools', included: true },
            { text: 'Dedicated AI/robotics engineer', included: true },
            { text: '24/7 priority support', included: true },
            { text: 'Joint R&D and co-development options', included: true }
        ], buttonText: 'Contact Sales', popular: false
    }
];

export const CaseStudiesData = [
    { image: 'https://designingmedia.com/artelligence/wp-content/uploads/2025/08/home-09-case1.jpg', category: 'Artificial Intelligence', title: 'Iris Analysis : The Scientific Study of one’s Brain through his Iris.' },
    { image: 'https://designingmedia.com/artelligence/wp-content/uploads/2025/08/home-09-case2.jpg', category: 'MedixCare Hospitals', title: 'Google is also working on Iris Analysis, in Health Sector' },
    { image: 'https://designingmedia.com/artelligence/wp-content/uploads/2025/08/home-09-case3.jpg', category: 'Logistics & Supply Chain', title: 'Start your Business with AI enabled Iris Analysis' }
];

export const StartFranchiseData = [
    { image: 'https://designingmedia.com/artelligence/wp-content/uploads/2025/08/home-09-case1.jpg', category: 'Artificial Intelligence', title: 'Apply for Franchise ' },
    { image: 'https://designingmedia.com/artelligence/wp-content/uploads/2025/08/home-09-case2.jpg', category: 'MedixCare Hospitals', title: 'Complete your Training & pass your Exam' },
    { image: 'https://designingmedia.com/artelligence/wp-content/uploads/2025/08/home-09-case3.jpg', category: 'Logistics & Supply Chain', title: 'Launch your Business ' }
];

export const TestimonialsData = [
    { quote: 'Artelligence delivered beyond expectations. Their robotics and AI systems completely transformed how we move inventory. Fulfillment times are faster, and the automation just works.', author: 'Kevin Andrew', role: 'CEO - Company', rating: 5 },
    { quote: 'Artelligence delivered beyond expectations. Their robotics and AI systems completely transformed how we move inventory. Fulfillment times are faster, and the automation just works.', author: 'Yennifer L. Hardy', role: 'CEO', rating: 5 },
    { quote: 'Artelligence delivered beyond expectations. Their robotics and AI systems completely transformed how we move inventory. Fulfillment times are faster, and the automation just works.', author: 'Jennifer L. Hardy', role: 'CEO', rating: 5 }
];

export const FAQsData = [
    {
        question: 'What is the accuracy of Iris Analysis?',
        answer: 'The accuracy ranges from 90% to 100%.'
    },
    {
        question: 'Can the result of Iris Analysis change?',
        answer: 'No. Iris Analysis reveals your innate traits that you are born with. Moreover, the analysis is based on Iris patterns, and these patterns do not change throughout life.'
    },
    {
        question: 'What is the business opportunity in Iris Analysis?',
        answer: 'You can run Iris Analysis Business under your own brand name and distribute your franchise globally.'
    },
    {
        question: 'How do you support the business seekers?',
        answer: 'We provide training, International Certification from USA, Marketing Support, Field Support, Counselors Network Support, Handholding, School/College Seminars, Online Webinars, and more.'
    },
    {
        question: 'What kind of infrastructure, office or team do I need?',
        answer: 'You don’t need any infrastructure. The business is 100% digital, automatic, and powered by AI. No office, no team, no setup is required. You may only hire a Digital Marketing Agency to promote your business online.'
    },
    {
        question: 'What is the business potential?',
        answer: 'The potential is unlimited and never-ending. The product best fits kids—and kids will always exist. So all kids are your potential customers. However, corporates are also potential clients.'
    },
    {
        question: 'Who will be our target customer?',
        answer: 'Kids, Students & Corporate Employees.'
    },
    {
        question: 'What is the USA affiliation with the American Research Institute of Dermis and Genetic Evaluation?',
        answer: 'The American Research Institute of Dermis and Genetic Evaluation, based in California, USA, is our research partner. We are officially affiliated with them. Every Iris Analyst & Counselor must undergo a robust training program and appear for an exam conducted by this institute. Only candidates scoring at least 75% will be eligible to run the Iris Analysis business.'
    },
    {
        question: 'What is the onboarding process if I want to take this as a business?',
        answer: 'Make the payment, complete your training, pass the exam, get access to the Iris Analysis software—and you are all set to start your own business.'
    },
    {
        question: 'Can I take this business without appearing for the exam of Iris Analyst & Counselor?',
        answer: 'No. Education and Certification are mandatory to become an Iris Analyst & Counselor.'
    },
    {
        question: 'What is the language of the report?',
        answer: 'Reports can be generated in 18 different languages: Hindi, Gujarati, Marathi, Punjabi, Bengali, Kannada, Tamil, Telugu, Malayalam, English, Spanish, French, German, Russian, Portuguese, Arabic, Mandarin, and Japanese. The original report is in English, and all other languages are translated using Google Translation.'
    }
];

export const BrandsData = [
    'https://designingmedia.com/artelligence/wp-content/uploads/2025/08/brand-logo-1.png',
    'https://designingmedia.com/artelligence/wp-content/uploads/2025/08/brand-logo-2.png',
    'https://designingmedia.com/artelligence/wp-content/uploads/2025/08/brand-logo-3.png',
    'https://designingmedia.com/artelligence/wp-content/uploads/2025/08/brand-logo-4.png',
    'https://designingmedia.com/artelligence/wp-content/uploads/2025/08/brand-logo-5.png',
    'https://designingmedia.com/artelligence/wp-content/uploads/2025/08/brand-logo-6.png'
];